export function isInteger(value) {
    if ( Number.isInteger ) {
        return Number.isInteger( value );
    } else {
        return typeof value === 'number' && isFinite( value ) && Math.floor( value ) === value;
    }
}

function baseExtend(deep, dist, obj) {
    for ( let prop in obj ) {
        if ( obj.hasOwnProperty( prop ) ) {
            if ( deep && Object.prototype.toString.call( obj[ prop ] ) === '[object Object]' ) {
                /** If we're doing a deep merge and the property is an object */
                dist[ prop ] = extend( true, dist[ prop ], obj[ prop ] );
            } else {
                /** Otherwise, do a regular merge */
                dist[ prop ] = obj[ prop ];
            }
        }
    }

    return dist;
}

export function merge() {
    let extended = {};

    /** Loop through each object and conduct a merge */
    for ( let i = 0; i < arguments.length; i++ ) {
        extended = baseExtend( true, extended, arguments[ i ] );
    }

    return extended;
}

export function extend() {
    let extended = {};

    /** Loop through each object and conduct a merge */
    for ( let i = 0; i < arguments.length; i++ ) {
        extended = baseExtend( false, extended, arguments[ i ] );
    }

    return extended;
}

export function only(obj, keys) {
    const properties = {};

    Object.keys( obj ).forEach( ( prop ) => {
        if ( keys.indexOf( prop ) !== -1 ) {
            properties[ prop ] = obj[ prop ];
        }
    } );

    return properties;
}

export function debounce(callback, delay){
    let timer;

    return () => {
        const args = arguments;
        const context = this;

        clearTimeout( timer );

        timer = setTimeout( () => {
            callback.apply( context, args );
        }, delay )
    }
}

export function throttle(callback, delay) {
    let last;
    let timer;

    return () => {
        const context = this;
        const now = +new Date();
        const args = arguments;

        if ( last && now < last + delay ) {
            clearTimeout(timer);

            timer = setTimeout( () => {
                last = now;
                callback.apply( context, args );
            }, delay );
        } else {
            last = now;
            callback.apply( context, args );
        }
    };
}

export function resolveBase64Value(value) {
    if ( typeof value === 'string' ) {
        try {
            value = decodeURIComponent( escape( atob( value ) ) );

            value = value.replace(/&quot;/g, '"');

            // value = atob( value );
            value = JSON.parse( value );
        } catch (e) { /* shhhh... */ }
    }

    return value;
}